import OurPromisesItem from './OurPromisesItems';
import type { OurPromisesItemProps, OurPromisesProps } from './types/propsTypes';
import styles from './OurPromises.module.scss';
const OurPromises = (props: OurPromisesProps) => (
  <div className={styles['our-promises-container']} data-testid={'our-promises-test-id'}>
    <h3 className={styles['our-promises-title-section']}>{props.title}</h3>
    <div className={styles['our-promises-image-info-container']}>
      <div className={styles['our-promises-image-section']}>
        {props.ourPromisesdata?.map((item: OurPromisesItemProps) => (
          <OurPromisesItem key={`${item.imageTitle}`} imagesData={item.imagesData} imageTitle={item.imageTitle} />
        ))}
      </div>
    </div>
  </div>
);

export default OurPromises;
export type { OurPromisesProps };
